import { AppBar, Toolbar } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import PropTypes from 'prop-types';

const ClockingsToolbar = ({ children, color = 'primary' }) => {
  const theme = useTheme();

  const APPBAR_MOBILE = 64;
  const APPBAR_DESKTOP = 92;

  const styleToolbar = {
    gap: 1.5,
    minHeight: APPBAR_MOBILE,
    padding: theme.spacing(0, 1, 0, 2),
    [theme.breakpoints.up('lg')]: {
      minHeight: APPBAR_DESKTOP,
      padding: theme.spacing(0, 5)
    }
  };

  return (
    <AppBar id="appbar" color={color} sx={{ paddingTop: 'env(safe-area-inset-top)' }}>
      <Toolbar id="toolbar" sx={styleToolbar}>
        {[children]}
      </Toolbar>
    </AppBar>
  );
};
ClockingsToolbar.propTypes = {
  children: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  color: PropTypes.string
};

export default ClockingsToolbar;
